import { makeStyles } from '@material-ui/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  root: {
    gap: '0.5rem',
  },
  body: {
    display: 'flex',
    gap: '0.5rem',
    flexDirection: 'column',
    gridAutoRows: 'min-content',
    gridTemplateColumns: 'auto min-content',
    fontSize: '0.75rem',
  },
  rtAvatarRoot: {
    width: 'fit-content',
    height: 'inherit',
    justifySelf: 'end',
  },
  avatarRoot: {
    width: '2rem',
    height: '2rem',
    fontSize: '1.2rem',
    backgroundColor: neutral['30'],
  },
  rtInfoContainer: ({ showRTInfo }) => ({
    display: showRTInfo ? 'flex' : 'none',
    gap: '1rem',
    alignItems: 'center',
    justifyContent: 'space-between',
  }),
  rtInfoWrapper: {
    display: 'flex',
    gap: '0.5rem',
    alignItems: 'center',
  },
  rtInfo: {
    display: 'grid',
    fontFamily: 'PP Object Sans',
    gridAutoRows: 'min-content',
  },
  rtName: {
    color: neutral['90'],
    fontSize: '0.875rem',
    fontFamily: 'PP Object Sans',
    fontWeight: 600,
  },
  secondaryInfo: {
    color: neutral['50'],
    fontFamily: 'PP Object Sans',
    fontSize: '0.75rem',
  },
  rtBtnCT: ({ showRTInfo }) => ({
    fontFamily: 'PP Object Sans',
    display: showRTInfo ? 'flex' : 'none',
    padding: '0.5rem 1rem',
    borderRadius: '0.5rem',
    border: `1px solid ${neutral[90]}`,
    color: neutral[100],
    fontSize: '0.875rem',
    fontWeight: 500,
    '&:hover': {
      borderColor: 'inherit',
      backgroundColor: 'inherit',
    },
  }),
  extraTextRoot: {
    gridColumn: '1 / 3',
    fontSize: '0.875rem',
    fontFamily: 'PP Object Sans',
    lineHeight: 1.8,
    color: neutral['90'],
  },
});
